// extracted by mini-css-extract-plugin
module.exports = {"root":"LpuUjmHmWiVBWP8pjE5G","hasBullets":"RqLRlvLSrmyZ0jbyxXpE","hasDividers":"M5f_GIoW2Px30p700uv4"};